import React from 'react';
import styled from 'styled-components';

const OverviewCardDivider = styled.div`
  width: 100%;
  height: 8px;
  border-bottom: ${props => `1px solid ${props.theme.colors.grey40}`};
`;

export default OverviewCardDivider;
